/**
 * @license Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import { AddReferenceCommand, RemoveReferenceCommand } from './referenceCommand';

export default class ReferenceEditing extends Plugin {
	init() {
		this._defineSchema();
		this._defineConverters();

		this.editor.commands.add(
			'addReference', new AddReferenceCommand( this.editor )
		);
		this.editor.commands.add(
			'removeReference', new RemoveReferenceCommand( this.editor )
		);
	}
	_defineSchema() {
		const schema = this.editor.model.schema;

    	// Register the reference element schema.
		schema.register( 'reference', {
            // Allow wherever text is allowed:
            allowWhere: '$text',

            // Allow reference text:
    		allowChildren: '$text',

            // The reference will act as an inline node:
            isInline: true,

			// isSelectable: true,

			isObject: true,

            // The reference can have the same attributes as text (for example linkHref, bold).
            allowAttributesOf: '$text',

            // The reference element will have a "reference" class
            allowAttributes: [ 'text' ]
        } );
	}

	_defineConverters() {
		const conversion = this.editor.conversion;

		// Conversion from a view element to a model element
		conversion.for( 'upcast' ).elementToElement( {
			view: {
				name: 'span',
				classes: 'reference'
			},
			model: ( viewElement, { writer: modelWriter } ) => {
				// Extract the reference text from the element.
                const text = viewElement.getChild( 0 ).data;

				return modelWriter.createElement( 'reference', { text } );
            }
		} );
		
        // Conversion from a model element to a view element
		conversion.for( 'downcast' ).elementToElement( {
			model: 'reference',
			view: ( modelItem, { writer: viewWriter } ) => {
				return viewWriter.createContainerElement( 'span', {
					class: 'reference',
				} );
			}
		} );
	}
}